import { createAction, props } from '@ngrx/store';

import { QuotePaymentViewDto, BucketCard, CreditPack } from '@marketplace/api';

const getSelectedCreditBundle = createAction('[Checkout] Get SelectedCreditBundle', props<{ payload: { id: string } }>());

const setSelectedCreditBundle = createAction('[Checkout] Set SelectedCreditBundle', props<{ payload: CreditPack }>());

const setSelectedCreditBundleFailure = createAction('[Checkout] Set SelectedCreditBundle Failure', props<{ payload: { status: number } }>());

const getQuoteToSend = createAction('[Checkout] Get QuoteToSend', props<{ payload: { id: string } }>());

const setQuoteToSend = createAction('[Checkout] Set QuoteToSend', props<{ payload: QuotePaymentViewDto }>());

const setQuoteToSendFailure = createAction('[Checkout] Set QuoteToSend Failure', props<{ payload: { status: number } }>());

const getCreditBundles = createAction('[Checkout] Get CreditBundles');

const setCreditBundles = createAction('[Checkout] Set CreditBundles', props<{ payload: CreditPack[] }>());

const setCreditBundlesFailure = createAction('[Checkout] Set CreditBundlesFailure', props<{ payload: { status: number } }>());

const setCreditBalanceFailure = createAction('[Checkout] Set CreditBalance Failure', props<{ payload: { status: number } }>());

const getCards = createAction('[Checkout] Get Cards');

const setCards = createAction('[Checkout] Set Cards', props<{ payload: BucketCard[] }>());

const setCardsFailure = createAction('[Checkout] Set Cards Failure', props<{ payload: { status: number } }>());

const getSpecialCreditBundle = createAction('[Checkout] Get SpecialCreditBundle', props<{ payload: { id: string } }>());

const setSpecialCreditBundle = createAction('[Checkout] Set SpecialCreditBundle', props<{ payload: CreditPack }>());

const setSpecialCreditBundleFailure = createAction('[Checkout] Set SpecialCreditBundle Failure', props<{ payload: { status: number } }>());

export const fromCheckoutActions = {
  setSelectedCreditBundleFailure,
  setSpecialCreditBundleFailure,
  getSelectedCreditBundle,
  setSelectedCreditBundle,
  setCreditBundlesFailure,
  setCreditBalanceFailure,
  getSpecialCreditBundle,
  setSpecialCreditBundle,
  setQuoteToSendFailure,
  getCreditBundles,
  setCreditBundles,
  setCardsFailure,
  getQuoteToSend,
  setQuoteToSend,
  getCards,
  setCards
};
